import ScheduleEntity, { ScheduleDay } from "../../domain/entities/ScheduleEntity";

const stringToDay = (day: string): ScheduleDay => {
    switch (day) {
        case "lunes":
            return ScheduleDay.lunes;
        case "martes":
            return ScheduleDay.martes;
        case "miercoles":
            return ScheduleDay.miercoles;
        case "jueves":
            return ScheduleDay.jueves;
        case "viernes":
            return ScheduleDay.viernes;
        case "sabado":
            return ScheduleDay.sabado;
        case "domingo":
            return ScheduleDay.domingo;
        default:
            return ScheduleDay.lunes;
    }
}

const dayToString = (day: ScheduleDay): string => {
    switch (day) {
        case ScheduleDay.lunes:
            return "lunes";
        case ScheduleDay.martes:
            return "martes";
        case ScheduleDay.miercoles:
            return "miercoles";
        case ScheduleDay.jueves:
            return "jueves";
        case ScheduleDay.viernes:
            return "viernes";
        case ScheduleDay.sabado:
            return "sabado";
        case ScheduleDay.domingo:
            return "domingo";
        default:
            return "lunes";
    }
}

const fromJSON = (json: any): ScheduleEntity => {
    return new ScheduleEntity({
        id: json['id']?.toString() ?? '',
        day: stringToDay(json['day']),
        openTime: json['open_hour'] ? json['open_hour'].substring(0, 5) : '00:00', // Convierte "08:00:00" a "08:00"
        closeTime: json['close_hour'] ? json['close_hour'].substring(0, 5) : '00:00', // Convierte "12:00:00" a "12:00"
        // stablishmentId: json['stablishment_id']?.toString() ?? '',
    });
}

const toJson = (schedule: ScheduleEntity): any => {
    return {
        id: schedule.id,
        // stablishment_id: schedule.stablishmentId,
        day: dayToString(schedule.day),
        open_hour: schedule.openTime,
        close_hour: schedule.closeTime,
    }
}

const fromJSONArray = (jsonArray: any[]): ScheduleEntity[] => {
    if (!Array.isArray(jsonArray)) {
        return [];
    }
    return jsonArray.map(fromJSON);
}

const toJsonArray = (schedules: ScheduleEntity[]): any[] => {
    return schedules.map(toJson);
}

export default {
    fromJSON,
    toJson,
    fromJSONArray,
    toJsonArray,
    stringToDay,
    dayToString,
}